import React, { ReactElement, ReactNode } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';
import Image, { ImageProps } from 'next/image';

import { TRANSITION_EASINGS } from '@/blocks/animations/transition-utils';
import { LinkI18n } from '@/i18n/routing';
import typography from '@/styles/typography.module.scss';

import styles from './masonry2x2.module.scss';

const MotionLink = motion(LinkI18n);

export type Masonry2x2CardData = {
  image: ImageProps['src'] | ReactElement;
  title: ReactNode;
  description: ReactNode;
  href?: string;
};

function isImageSrc(val: any): val is ImageProps['src'] {
  return typeof val === 'string' || val.hasOwnProperty('src');
}

const cardVariant = {
  active: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      easing: TRANSITION_EASINGS.easeInCubic,
    },
  },
  inactive: {
    opacity: 0,
    y: 15,
    transition: {},
  },
};

export function Masonry2x2Card(props: { card: Masonry2x2CardData }) {
  const isLink = typeof props.card.href === 'string';
  const Wrapper = isLink ? MotionLink : motion.div;

  return (
    <Wrapper
      href={props.card.href!}
      className={classNames(styles.card, isLink && styles.cardHoverable)}
      variants={cardVariant}
    >
      <div className={styles.imgWrapper}>
        {isImageSrc(props.card.image) ? (
          <Image src={props.card.image} alt="" width={80} height={80} />
        ) : (
          props.card.image
        )}
      </div>
      <h4 className={classNames(styles.cardTitle, typography.h4)}>{props.card.title}</h4>
      <p className={classNames(styles.cardDescriptioon, typography.subheadingML)}>{props.card.description}</p>
    </Wrapper>
  );
}

export default Masonry2x2Card;
